import React,{Component} from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";

import Button from '@material-ui/core/Button';
import TextField from "@material-ui/core/TextField";
import MenuItem from '@material-ui/core/MenuItem';

import Api from "../../../libraries/api";
import ErrorHandling from "../../../libraries/error-handling";
import { history } from "../../../shared/configure-store";

require('dotenv').config();
const validator = new SimpleReactValidator({locale: process.env.REACT_APP_LOCALE});

class BanksAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loadingButton: false,
            errors: {},
            showAdd: false,
            name: '',
            detail: '',
            branch: '',
            address: '',
            beneficiary_acc_no: '',
            beneficiary_name: '',
            currency: '',
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        document.title = 'Abadi - Add Bank';
    }

    handleChange (e, prop){
        this.setState({ [prop]: e.target.value });
    };

    showMessage = (status, message) => {
        if (status) toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT });
        else toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        if (!validator.allValid()) {
            this.setState({ errors: validator.getErrorMessages() });
            return false;
        }

        this.setState({ errors: {}, loading: true });

        let params = {
            name : this.state.name,
            branch : this.state.branch,
            address : this.state.address,
            beneficiary_acc_no : this.state.beneficiary_acc_no,
            beneficiary_name : this.state.beneficiary_name,
            currency : this.state.currency,
        };

        Api.post('/bank', params, false).then(resp => {
            this.setState({ loading: false });
            history.push('/banks');
            this.showMessage(true, 'Bank added');
        }).catch(err => {
            if (ErrorHandling.checkErrorTokenExpired(err)){
            } else {
                this.setState({ errors: err.errors, loading: false });
                this.showMessage(false, 'Invalid format data');
            }
        });
    };

    handleGo  = (link) => {
        history.push(link);
    };

    render() {
        return (
            <div className="row main-content">
                <div className="col-12 px-lg-5">
                    <h1 className="page-title">Create Bank</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/banks" >Bank</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Create</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12 mt-3 px-lg-5">
                    <div className="table-wrapper">
                        <form name="add" id="addType" className="row" noValidate>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Name</label>
                                    <TextField
                                        variant="outlined"
                                        type='text'
                                        id='name'
                                        name="name"
                                        label="Name"
                                        onChange={(e) => this.handleChange(e, 'name')}
                                        value={this.state.name}
                                        autoComplete="off"
                                        fullWidth
                                    />
                                    {validator.message('name', this.state.name, 'required')}
                                    <div className='text-danger'>{this.state.errors.name}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Branch</label>
                                    <TextField
                                        variant="outlined"
                                        type='text'
                                        id='branch'
                                        name="branch"
                                        label="Branch"
                                        onChange={(e) => this.handleChange(e, 'branch')}
                                        value={this.state.branch}
                                        autoComplete="off"
                                        fullWidth
                                    />
                                    {validator.message('branch', this.state.branch, 'required')}
                                    <div className='text-danger'>{this.state.errors.branch}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Address</label>
                                    <TextField
                                        variant="outlined"
                                        type='text'
                                        id='address'
                                        name="address"
                                        label="Branch"
                                        onChange={(e) => this.handleChange(e, 'address')}
                                        value={this.state.address}
                                        autoComplete="off"
                                        fullWidth
                                    />
                                    {validator.message('address', this.state.address, 'required')}
                                    <div className='text-danger'>{this.state.errors.address}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Beneficiary Account Number</label>
                                    <TextField
                                        variant="outlined"
                                        type='text'
                                        id='beneficiary_acc_no'
                                        name="beneficiary_acc_no"
                                        label="Branch"
                                        onChange={(e) => this.handleChange(e, 'beneficiary_acc_no')}
                                        value={this.state.beneficiary_acc_no}
                                        autoComplete="off"
                                        fullWidth
                                    />
                                    {validator.message('beneficiary_acc_no', this.state.beneficiary_acc_no, 'required')}
                                    <div className='text-danger'>{this.state.errors.branch}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Beneficiary Name</label>
                                    <TextField
                                        variant="outlined"
                                        type='text'
                                        id='beneficiary_name'
                                        name="beneficiary_name"
                                        label="Branch"
                                        onChange={(e) => this.handleChange(e, 'beneficiary_name')}
                                        value={this.state.beneficiary_name}
                                        autoComplete="off"
                                        fullWidth
                                    />
                                    {validator.message('beneficiary_name', this.state.beneficiary_name, 'required')}
                                    <div className='text-danger'>{this.state.errors.beneficiary_name}</div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Currency</label>
                                    <TextField 
                                        variant="outlined"
                                        id="currency"
                                        name="currency"
                                        label="Currency"
                                        onChange={(e) => this.handleChange(e, 'currency')}
                                        value={this.state.currency}
                                        fullWidth
                                        select
                                    >
                                        <MenuItem value="IDR">IDR</MenuItem>
                                        <MenuItem value="USD">USD</MenuItem>
                                    </TextField>
                                    {validator.message('currency', this.state.currency, 'required')}
                                    <div className='text-danger'>{this.state.errors.currency}</div>
                                </div>
                            </div>
                            <div className="col-12 text-center">
                                <Button
                                    variant="contained"
                                    className="mr-3"
                                    onClick={() => this.handleGo('/banks')}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className=""
                                    onClick={this.handleSubmit}
                                    disabled={this.state.loadingButton && 'disabled' }
                                >
                                    Submit{ this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i> }
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
                <ToastContainer autoClose={3000} />
            </div>
        )
    }
}

export default BanksAdd;
